let customerId = null;
let orderId= null;

function cancelOrder() {
  let cancelReason = 'customer';
  // let selectedReason = document.getElementById("cancelReason");
  // cancelReason = selectedReason.getAttribute('data-type');
  const SPINNER = document.querySelector('.cancel-spinner')
  const CONFIRM_TEXT = document.querySelector('.cancel-order-confirm')
  CONFIRM_TEXT.style.color = "transparent";
  SPINNER.classList.remove('hide-spinner');

  checkIfStillValid();
  const token = JSON.parse(localStorage.getItem('jwtToken'));

  if (cancelReason) {
    $.ajax({
      method: "POST",
      headers: {
        Authorization: 'Bearer ' + token.access_token 
      },
      url: SHOPIFY_API + 'us/order/api/orders/cancel', //external api via custom app
      data: {
        order_id: orderId,
        customer_id: customerId,
        reason: cancelReason //customer, inventory, fraud, declined, and other.
      }
    })
    .done(function( msg ) {
      // clearReasonSelection();
      SPINNER.classList.add('hide-spinner');
      CONFIRM_TEXT.style.color = "#111111";
      CONFIRM_TEXT.innerHTML = "Cancelled";
      location.reload();
    });
  }
}

// Get the modal
let modal = document.getElementById("jsCancelOrderModal");

// Get the button that opens the modal
// let btn = document.getElementById("jsOpenCancelModal");

let btnModals = document.querySelectorAll("#jsOpenCancelModal");
btnModals.forEach((btn) => {
  // When the user clicks the button, open the modal 
  btn.onclick = function() {
    customerId = btn.dataset.customerId;
    orderId = btn.dataset.orderId;
    modal.style.display = "flex";
  }
});

// Get the <span> element that closes the modal
let span = document.getElementsByClassName("close")[0];

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
  clearReasonSelection();
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    clearReasonSelection();
  }
}

const select = document.querySelectorAll('.selectBtn');
const option = document.querySelectorAll('.option');
let index = 1;

select.forEach(a => {
	a.addEventListener('click', b => {
		const next = b.target.nextElementSibling;
		next.classList.toggle('toggle');
		next.style.zIndex = index++;
	})
})

option.forEach(a => {
	a.addEventListener('click', b => {
		b.target.parentElement.classList.remove('toggle');
		const parent = b.target.closest('.custom-select').children[0];
		parent.setAttribute('data-type', b.target.getAttribute('data-type'));
		parent.innerText = b.target.innerText;
	})
})

function clearReasonSelection() {
  select.forEach(a => {
    a.parentElement.children[1].classList.remove('toggle');
    a.setAttribute('data-type', '');
    a.innerText = "Select a reason";
  })
}